import styled from '@emotion/styled'
import { FiBell, FiChevronRight } from 'react-icons/fi'

export const DropdownContainer = styled.div`
  width: 380px;
  max-height: 500px;
  overflow-y: auto;
  background: ${({ theme }: any) => theme.colors.white};
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
  padding: 16px 0;
  z-index: 1000;
  border: 1px solid ${({ theme }: any) => theme.colors.borderColor};
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px 8px 16px;
`

export const Title = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }: any) => theme.colors.text};
  gap: 8px;
`

export const BellIcon = styled(FiBell)`
  color: ${({ theme }: any) => theme.colors.textGrey};
`

export const ChevronIcon = styled(FiChevronRight)`
  margin-left: 4px;
`

export const ViewAll = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  color: ${({ theme }: any) => theme.colors.textGrey};
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: ${({ theme }: any) => theme.colors.primary};
  }
`

export const UnreadCount = styled.div`
  background: ${({ theme }: any) => theme.colors.primary};
  color: #ffffff;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 10px;
  margin-left: 6px;
`

export const Divider = styled.div`
  height: 1px;
  background: ${({ theme }: any) => theme.colors.borderColor};
  margin: 8px 0;
`

export const Empty = styled.div`
  text-align: center;
  padding: 32px 0;
  font-size: 14px;
  color: ${({ theme }: any) => theme.colors.text50};

  & > div {
    margin-top: 12px;
    font-weight: 500;
  }
`

export const EmptyIcon = styled.div`
  width: 48px;
  height: 48px;
  margin: 0 auto;
  background: ${({ theme }: any) => theme.colors.brown50};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }: any) => theme.colors.text50};
`

export const EmptySubtext = styled.div`
  font-size: 13px;
  color: ${({ theme }: any) => theme.colors.text50};
  margin-top: 4px;
`

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
`

export const Item = styled.li<{ unread?: boolean; theme?: any }>`
  padding: 12px 16px;
  border-left: 3px solid
    ${({ unread, theme }: any) =>
      unread ? theme.colors.primary : 'transparent'};
  background: ${({ unread, theme }: any) =>
    unread ? theme.colors.primaryLight : theme.colors.white};
  transition: background 0.2s;
  cursor: pointer;

  &:hover {
    background: ${({ theme }: any) => theme.colors.brown50};
  }

  & + & {
    border-top: 1px solid ${({ theme }: any) => theme.colors.borderColor};
  }
`

export const ItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 6px;
  position: relative;
`

export const ItemTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: ${({ theme }: any) => theme.colors.text};
  padding-right: 16px;
`

export const ItemTime = styled.div`
  font-size: 12px;
  color: ${({ theme }: any) => theme.colors.text50};
  flex-shrink: 0;
`

export const UnreadBadge = styled.div`
  position: absolute;
  left: -10px;
  top: 6px;
  width: 8px;
  height: 8px;
  background: ${({ theme }: any) => theme.colors.primary};
  border-radius: 50%;
`

export const ItemBody = styled.div`
  font-size: 13px;
  color: ${({ theme }: any) => theme.colors.textGrey};
  line-height: 1.4;
  margin-bottom: 8px;
`

export const ItemFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ItemDate = styled.div`
  font-size: 12px;
  color: ${({ theme }: any) => theme.colors.text50};
`

export const MarkReadButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }: any) => theme.colors.placeholder};
  cursor: pointer;
  padding: 2px;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    color: ${({ theme }: any) => theme.colors.textGrey};
    background: ${({ theme }: any) => theme.colors.borderColor};
  }
`
